/**
 * @description Positions a table/grid row dropdown menu correctly, based on flex-grid-anchor
 * @example
 * <ul uib-dropdown-menu grid-action-menu class="dropdown-menu" role="menu">
 *     <li>Foo</li>
 *     <li>Bar</li>
 * </ul>
 */
;(function () {
  angular
    .module('contrast.grid-action-menu')
    .directive('gridActionMenu', function ($, $log, $window) {
      'ngInject'

      return {
        restrict: 'A',
        link: function (scope, angularElement) {
          var element = $(angularElement[0]),
            button = element.parent().find('button'),
            flexGridAnchor = element.parents('div[flex-grid-anchor]'),
            buttonLeftInitial = 0

          function onAnchorScroll() {
            if (element.css('display') !== 'none') {
              setElementPosition()
              if (isButtonClipped()) {
                button.click()
              }
            }
          }

          function setElementPosition() {
            var buttonLeftOffset = buttonLeftInitial - button.offset().left,
              offset = element[0].clientWidth - button[0].clientWidth

            element.css(
              'transform',
              'translateX(-' + (offset + buttonLeftOffset) + 'px)'
            )
          }

          function isButtonClipped() {
            if (
              !button ||
              !button.length ||
              !flexGridAnchor ||
              !flexGridAnchor.length
            ) {
              $log.warn('GridActionMenu: Button or flexGridAnchor is not found')
              return true
            }

            if (!button.offset() || !flexGridAnchor.offset()) {
              $log.warn('GridActionMenu: Unable to retrieve element offsets')
              return true
            }

            var buttonRight = button.offset().left + button[0].clientWidth
            var gridRight =
              flexGridAnchor.offset().left + flexGridAnchor[0].clientWidth

            return gridRight < buttonRight
          }

          function onWindowResize() {
            onAnchorScroll()
          }

          if (flexGridAnchor && button) {
            flexGridAnchor.scroll(onAnchorScroll)
            buttonLeftInitial = button.offset().left
            scope.toggled = function (open) {
              if (open) {
                buttonLeftInitial = button.offset().left
                setElementPosition()
              }
            }
            setElementPosition()
            $window.addEventListener('resize', onWindowResize)
          } else {
            if (!button) {
              $log.error('GridActionMenu: Unable to find drop down button')
            }
            if (!flexGridAnchor) {
              $log.error('GridActionMenu: Unable to find flex grid anchor')
            }
          }
        }
      }
    })
})()
